import { Model } from '@vuex-orm/core'

const resolvers = {}

export default class MobileDrawer extends Model {
  static entity = '_mobiledrawer'

  static fields() {
    return {
      id: this.uid(),
      isOpen: this.attr(false),
      params: this.attr(null)
    }
  }

  async open(params) {
    const promise = new Promise((resolve, reject) => {
      resolvers[this.id] = {
        resolve,
        reject
      }
    })
    this.isOpen = true
    this.params = params
    await this.$save()
    return promise
  }

  async close(data, confirmed = true) {
    if (!this) {
      return
    }
    if (confirmed) {
      this.resolvePromise(data)
    } else {
      this.rejectPromise(data)
    }

    this.isOpen = false
    this.params = null
    await this.$save()
  }

  resolvePromise(data) {
    resolvers[this.id] && resolvers[this.id].resolve(data)
  }

  rejectPromise(data) {
    resolvers[this.id] && resolvers[this.id].reject(data)
  }
}
